<app-side-menu></app-side-menu>
<div class="header">
    <div class="logo">
        <h4 class="text"><img alt="" alt="" class="dashboard-img" src="../../assets/images/dash-icon.png">Summary Reports </h4>
    </div>

    <div class="toggle-icon">
        <button class="btn btn-theme me-3">Create</button>
        <img alt="" alt="" src="../../assets/images/user.png">
    </div>

</div>

<mat-drawer-container class="drawercontainer">
    <div class="main-page-wrapper">
    </div>
    </mat-drawer-container>